"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
require("./styles/app.scss");
require("./components/MainMenu");
require("./components/DropdownMenu");
require("./components/BlogVideo");
var vue_1 = require("vue");
// @ts-ignore
var vue3_progressbar_1 = __importDefault(require("@aacassandra/vue3-progressbar"));
var MasonryGrid_1 = require("./components/MasonryGrid");
var Carousel_1 = require("./components/Carousel");
var ProductPageCarousel_1 = require("./components/ProductPageCarousel");
var Slides_1 = require("./components/Slides");
var Slide_1 = require("./components/Slide");
var NewsletterForm_1 = require("./components/NewsletterForm");
var Spinner_1 = require("./components/Spinner");
var ContactForm_1 = require("./components/ContactForm");
var RatingForm_1 = require("./components/RatingForm");
exports["default"] = vue_1.createApp({
    components: {
        Spinner: Spinner_1.Spinner,
        MasonryGrid: MasonryGrid_1.MasonryGrid,
        MasonryGridItem: MasonryGrid_1.MasonryGridItem,
        Carousel: Carousel_1.Carousel,
        ProductPageCarousel: ProductPageCarousel_1.ProductPageCarousel,
        Slides: Slides_1.Slides,
        Slide: Slide_1.Slide,
        NewsletterForm: NewsletterForm_1.NewsletterForm,
        ContactForm: ContactForm_1.ContactForm,
        RatingForm: RatingForm_1.RatingForm,
    }
})
    .use(vue3_progressbar_1["default"], {
    color: '#13b955',
    failedColor: 'red',
    thickness: '3px',
    autoFinish: false
})
    .mount('#app');
